import React from "react";
import { useNavigate } from "react-router-dom";
import { getCookie } from "utils";
import { ProfileDropDownSkelton } from ".";

import arrowRightIcons from "assets/images/icons/arrow-right-icon-dark.svg";
import userProfile from "assets/images/icons/user-drop-icon.svg";
import certificateIcon from "assets/images/icons/certificate-icon-black.svg";
import activatiionCodeIcon from "assets/images/icons/activation-code-icon.svg";
import logoutIcon from "assets/images/icons/logout-icon.svg";
import Frame from "assets/images/Frame.svg";
import "../styles/profileDropDown.styles.css";
import { useAppScope } from "master";
import { ProfileText } from "..";

export const ProfileDropDown = ({
  onOpenModal,
  profileQuery,
  attendanceProgram = [],
}) => {
  const navigate = useNavigate();
  const { lanSettings, isMWCD } = useAppScope();
  const { isLoading, data } = profileQuery;
  const localData = JSON.parse(getCookie("_stu_user_data"));
  const isExternal = localData?.isExternal ? true : false;
  const hasAttendanceProgram = attendanceProgram?.length > 0;

  const handleDropDown = (value) => {
    switch (value) {
      case "password":
        onOpenModal({ actionFrom: "changePassword", info: "" });
        break;
      case "activationCode":
        onOpenModal({ actionFrom: "activationCode", info: "" });
        break;
      case "attendance":
        localStorage.clear("_stu_selectedProgram");
        navigate("/attendance");
        break;
      case "certificate":
        localStorage.clear("_stu_selectedProgram");
        navigate("/certificate");
        break;
      default:
        break;
    }
  };

  return (
    <div className={`header-card header-dropdown header-user-card`}>
      {isLoading ? (
        <>
          <ProfileDropDownSkelton />
        </>
      ) : (
        <div className="header-card-content">
          <div className="user-basic-info d-flex align-items-center p-3">
            <div className="user-avatar">
              <span>
                {data?.firstName?.substring(0, 1)}
                {data?.lastName ? data.lastName.substring(0, 1) : ""}
              </span>
            </div>
            <div className="user-info-text">
              <h3 className="user-name-txt">
                {data?.firstName} {data?.lastName}
              </h3>
              <div className="user-sub-txt user-email">
                {isMWCD ? data?.phoneNumber : data?.emailAddress}
              </div>
            </div>
          </div>
          <div className="actions-list">
            {!isExternal && lanSettings?.key !== "mwcd" && (
              <>
                <button
                  className="action-btn"
                  onClick={() => handleDropDown("password")}
                >
                  <div className="action-btn-content">
                    <img src={userProfile} alt="" />
                    <span>Profile</span>
                  </div>
                  <span className="btn-arrow">
                    <img src={arrowRightIcons} alt="" />
                  </span>
                </button>
                <button
                  className="action-btn"
                  onClick={() => handleDropDown("activationCode")}
                >
                  <div className="action-btn-content">
                    <img src={activatiionCodeIcon} alt="" />
                    <span>Activation Code</span>
                  </div>
                  <span className="btn-arrow">
                    <img src={arrowRightIcons} alt="" />
                  </span>
                </button>
              </>
            )}
            <button
              className="action-btn"
              onClick={() => handleDropDown("certificate")}
            >
              <div className="action-btn-content">
                <img src={certificateIcon} alt="" />
                <span>{ProfileText.Certificates[lanSettings?.lan || "en"]}</span>
              </div>
              <span className="btn-arrow">
                <img src={arrowRightIcons} alt="" />
              </span>
            </button>
            {hasAttendanceProgram && (
              <button
                className="action-btn"
                onClick={() => handleDropDown("attendance")}
              >
                <div className="action-btn-content">
                  <img src={Frame} alt="" />
                  <span>Attendance</span>
                </div>
                <span className="btn-arrow">
                  <img src={arrowRightIcons} alt="" />
                </span>
              </button>
            )}

            <button
              className="action-btn"
              onClick={() =>
                onOpenModal({
                  actionFrom: "logoutModal",
                })
              }
            >
              <div className="action-btn-content">
                <img src={logoutIcon} alt="" />
                <span>{ProfileText.Logout[lanSettings?.lan || "en"]}</span>
              </div>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
